import React from 'react';
import './App.css';
import ArtFetcher from './ArtFetcher';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <ArtFetcher />
      </header>
    </div>
  );
}

export default App;
